import { ApiRouteKey, RouteParams } from './types';

import { API_ROUTES } from './routes';

export function getApiEndpoint<K extends ApiRouteKey>(
  key: K,
  ...[params]: RouteParams<K> extends never ? [] : [Record<RouteParams<K>, string | number>]
): string {
  let url: string = API_ROUTES[key];

  if (params) {
    for (const [p, value] of Object.entries(params)) {
      url = url.replace(`:${p}`, String(value));
    }
  }

  return url;
}
